<template>
	<section id="tema">
		<iframe id="iframeContent" ref="iframeContent" width="100%" :height="windowHeight - 7"
			:src="url">
		</iframe>
	</section>
</template>

<script>
import { integracao } from '@/services/integracoes'
export default {
	name: 'ClienteList',
	data () {
		return {
			windowHeight: 0,
			url: '',
			matricula: '',
			nomeAluno: '',
			temaId: {}
		}
	},
	async created () {
		const temaId = this.$route.query.temaId
		this.temaId = temaId

		const windowHeight = window.innerHeight
		this.windowHeight = windowHeight

		try {
			const tema = await integracao.obterUrl({ temaId })
			this.url = tema.data.body.urlArquivo
			this.matricula = tema.data.body.matricula
			this.nomeAluno = tema.data.body.nomeAluno
			this.loadTema()
		} catch (err) {
			this.$router.push('/login')
		}
	},
	methods: {
		loadTema () {
			this.frame = this.$refs.iframeContent.contentWindow
			const conteudo = {
				studentName: this.nomeAluno,
				studentNumber: this.matricula,
				origin: 'player',
				clientId: '0AE405A2-8663-DB4D-0F4B-4EB6E1719049',
				themeId: this.temaId
			}

			const readyAction = function (evt) {
				if (typeof evt.data.waiting !== 'undefined' && evt.data.waiting === 'true') {
					document.getElementById('iframeContent').contentWindow.postMessage(conteudo, '*')
					window.removeEventListener('message', readyAction)
				}
			}
			window.addEventListener('message', readyAction)
		}
	}
}
</script>

<style lang="scss">
body {
	background-color: #fff !important;
	background-image: none !important;
}
</style>
